<template>
    <div id="onlineMsg">

      <div  class="service" v-show="showMessageIcon">
        <a-popover placement="left">
          <template slot="content" style="padding: 0px">
            <img src="../../assets/img/yyqrcode.png" width="150px"/>
          </template>
          <div>
            <a-icon type="mobile" style="font-size: 40px;color: #FFFFFF"/>
            <p>移动端</p>
          </div>
        </a-popover>
        <div style="width: 80%;border-bottom: 2px solid #FFFFFF;height: 0px;margin: 10px auto"></div>
        <div @click="showOnlineMessage">
          <a-icon type="form" style="font-size: 40px;color: #FFFFFF"/>
          <p>在线留言</p>
        </div>
        <div style="width: 80%;border-bottom: 2px solid #FFFFFF;height: 0px;margin: 10px auto"></div>
        <div @click="showMessageIcon=false">
<!--          <a-icon type="close-circle" style="font-size: 40px;color: #FFFFFF"/>-->
          <p><a-icon type="close-circle" style="color: #FFFFFF"/>关闭</p>
        </div>
      </div>


        <div>
            <a-modal
                    title="在线留言"
                    :visible="showMessage"
                    width="800px"
                    centered
                    @cancel="handleCancelMessage"
            >
                <template slot="footer">
                    <a-button key="back" @click="handleCancelMessage">
                        关闭
                    </a-button>
                    <a-button key="submit" type="primary" :loading="msgLoading"  html-type="submit" @click="handleOkMessage">
                        提交
                    </a-button>
                </template>
                <!--背景图-->
                <div class="backMsgImg"/>
                <span style="position: absolute;
                    top: 100px;
                    left: 140px;
                    font-size: 30px;">
                    感谢您的意见和建议
                </span>
                <a-form ref="formMsgRef" :form="formMessage" @submit="submitMessage">
                        <span style="color: rgba(0, 0, 0, 0.85);margin: 0px 0px 20px 10px;display: block;">
                            单位名称：{{$store.state.account.department}}
                        </span>
                    <a-row :gutter="16">
                        <a-col :span="8">
                            <a-form-item label="联系人" >
                                <a-input
                                        placeholder="请输入联系人"
                                        v-decorator="[
                                              'contacts',
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: '请填写联系人',
                                                  }
                                                ],
                                              },
                                            ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="联系电话" >
                                <a-input
                                        placeholder="请填写您的联系电话"
                                        v-decorator="[
                                    'contactnumber',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写您的联系电话'
                                            },
                                             {
                                                  pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
                                                  message: '请输入正确的号码'
                                             }
                                        ]
                                    }
                                ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="邮件地址">
                                <a-input
                                        placeholder="请填写您的邮件地址"
                                        v-decorator="[
                                    'emailaddress',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写您的邮件地址'
                                            }
                                        ]
                                    }
                                ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="留言主题">
                                <a-input
                                        placeholder="请填写您的留言主题"
                                        v-decorator="[
                                    'messagesubject',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写您的留言主题'
                                            }
                                        ]
                                    }
                                ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="建议意见">
                                <a-input
                                        placeholder="请填写您的建议意见"
                                        type="textarea"
                                        :auto-size="{ minRows: 3, }"
                                        v-decorator="[
                                    'problemdescription',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写您的建议意见'
                                            }
                                        ]
                                    }
                                ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-modal>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import {mapGetters, mapState} from "vuex";
import {
    addOnlineMessage,//添加在线留言
} from '@/api/finance/finance.js'

moment.locale('zh-cn');
export default {
    computed: {
        ...mapState(["downPath", "menuSourceList"]),
        ...mapGetters(["systemName", "footOrganizer", "footSupport", "storeAccount"]),
    },
    name: "OnlineMessage",
    data() {
        return {
            value: "",
            formMessage:  this.$form.createForm(this),
            showMessage: false,
            showMessageIcon: true,
            msgLoading: false,
            message:{
                companyname:null,
                contacts:null,
                contactnumber:null,
                messagesubject:null,
                problemdescription:null,
                emailaddress:null,
            },
        }
    },
    beforeRouteEnter(to, form, next) {
        next(vm => {

        })
    },
    methods: {
        init() {
            //初始化
        },
        showOnlineMessage(){
            //登录
            if(this.$store.state.account.accountNonExpired){
                this.showMessage = true;
            }else {
                this.$message.info("登录之后才能留言！")
                // this.$router.push({name: "Login",query:{type:2,msg:1}});
            }
        },
        handleOkMessage(){
            // this.showMessage = false;
            // this.formMessage;
            this.$refs.formMsgRef.onSubmit();
        },
        handleCancelMessage(){
            this.showMessage = false;
            this.formMessage.resetFields();
        },
        submitMessage(value){
            this.formMessage.validateFields((err,value)=>{
                if(!err){
                    this.msgLoading = true;
                    value.accountId = this.$store.state.account.id;
                    value.companyname = this.$store.state.account.department;
                    value.createdAt = new Date();
                    addOnlineMessage(value).then(resp=>{
                        if(resp.data.success == "TRUE"){
                            this.msgLoading = false;
                            this.showMessage = false;
                            this.formMessage.resetFields();
                            this.$message.success("提交成功！")
                        }else {
                            this.$message.error(resp.data.message)
                            this.msgLoading = false;
                        }
                    }).catch(()=>{
                        this.msgLoading = false;
                        this.$message.error("服务器异常，请稍后再试")
                    })
                }
            })
        },
    }
}
</script>

<style scoped>
.service {
  display: inline-block;
  width: 80px;
  padding: 10px 0px;
  background-color: #1e9cfe;
  color: #FFFFFF;
  position: fixed;
  right: 5px;
  top: 60%;
  z-index: 99;
  cursor: pointer;
  text-align: center;
}
     .backMsgImg{
         height:100px;
         background-image: url('../../assets/img/messageback.png');
         background-size: 100%;
         margin-bottom: 30px;
     }

     .iconCancel {
         display: flex;
         justify-content: flex-end;
         align-content: flex-end;
     }

    .posiCls {
        z-index: 99;
        position: fixed;
        top: 80%;
        right: 50px;
        width: 92px;
    }
</style>
